var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { lighten } from "polished";
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  bottom: 0px;\n  width: 100%;\n  height: 8px;\n  background-color: ", ";\n  pointer-events: none;\n  user-select: none;\n  border-radius: 5px;\n  display: flex;\n  ", "\n"], ["\n  position: relative;\n  bottom: 0px;\n  width: 100%;\n  height: 8px;\n  background-color: ", ";\n  pointer-events: none;\n  user-select: none;\n  border-radius: 5px;\n  display: flex;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.light;
}, function (_a) {
    var forMobile = _a.forMobile;
    return (forMobile ? "width: calc(100% - 30px);" : "");
});
export var Seek = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 5px;\n  background: linear-gradient(to right, ", ", ", ");\n  transition: width ", " ease;\n  width: ", ";\n"], ["\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 5px;\n  background: linear-gradient(to right, ", ", ", ");\n  transition: width ", " ease;\n  width: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return lighten(0.3, theme.colors.perkbox.blue);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.perkbox.blue;
}, function (_a) {
    var delay = _a.delay;
    return (delay ? "1s" : "0.25s");
}, function (_a) {
    var width = _a.width;
    return width + "%";
});
var templateObject_1, templateObject_2;
